<template>
  <v-container fluid fill-height style="background-color:#1976D2">
    <v-dialog v-model="dialogFirstTime" persistent style="max-height:97%;height:100%">
      <v-window
        v-model="step"
        class="main_window"
        height="100%"
        style="height: 100%;-webkit-box-shadow:none!imporant;box-shadow:none!imporant;"
      >
        <!-- Welcome screen -->
        <v-window-item :value="1">
          <v-card-text>
            <div class="text-xs-center" style="height: 90%;">
              <v-img v-bind:src="computeLogo" class="mb-3" contain height="300"></v-img>
              <h3 class="title font-weight-light mb-2 d-flex justify-center" style="color: #141414">
                Welcome to Regular.li
              </h3>
              <h5 class="d-flex justify-center" style="color: #141414">Let's setup the basics</h5>
            </div>
          </v-card-text>
        </v-window-item>

        <!-- security settings -->
        <v-window-item :value="2">
          <v-card-text>
            <div style="text-align: center; padding: 0px 40px">
              <h4 class="title font-weight-light">Security</h4>
              <p>Secure Attendances using Location, Photo and WiFi</p>
            </div>

            <v-divider style="margin: 10px 0px"></v-divider>

            <v-layout row class="pa-1">
              <v-flex xs12 sm12 style="padding: 0px 10px ">
                <v-layout row wrap>
                  <v-flex xs10 sm9 style="text-align: left">
                    <h3>GeoSeal</h3>
                    <small>Checks whether Attendance was marked inside premises</small>
                  </v-flex>
                  <v-flex xs2 sm3 style="text-align: right">
                    <v-switch
                      v-model="editedItem.securitySettings.isGeoseal"
                      color="primary"
                    ></v-switch>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs10 sm9 style="text-align: left">
                    <h3>Enable PhotoID</h3>
                    <small>Takes a selfie during Attendance</small>
                  </v-flex>
                  <v-flex xs2 sm3 style="text-align: right">
                    <v-switch
                      v-model="editedItem.securitySettings.isPhotoid"
                      color="primary"
                    ></v-switch>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs10 sm9 style="text-align: left">
                    <h3>Enable Wifi</h3>
                    <small>Checks whether Attendance was marked using mapped WiFi</small>
                  </v-flex>
                  <v-flex xs2 sm3 style="text-align: right">
                    <v-switch
                      v-model="editedItem.securitySettings.isWifissid"
                      color="primary"
                    ></v-switch>
                  </v-flex>
                </v-layout>

                <v-layout row wrap style="padding-top: 2%;">
                  <v-flex xs12 sm12 md12 style="margin-bottom: 7px">
                    <v-expansion-panels>
                      <v-expansion-panel v-for="(item, i) in 1" :key="i">
                        <v-expansion-panel-header expand-icon="mdi-menu-down">
                          <v-flex xs12 text-xs-right class="customFont">Advanced</v-flex>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-layout row wrap>
                            <v-flex xs10 sm9 style="text-align: left">
                              <h3>Match Device</h3>
                              <small>Alerts if member's attendance device changes</small>
                            </v-flex>
                            <v-flex xs2 sm3 style="text-align: right">
                              <v-switch
                                v-model="editedItem.securitySettings.matchDevice"
                                color="primary"
                              ></v-switch>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs10 sm9 style="text-align: left">
                              <h3>Covid Alerts (India)</h3>
                              <small
                                >Sends an alert if checkins were made inside a Covid hotspot</small
                              >
                            </v-flex>
                            <v-flex xs2 sm3 style="text-align: right">
                              <v-switch
                                v-model="editedItem.securitySettings.detectHotspot"
                                color="primary"
                              ></v-switch>
                            </v-flex>
                          </v-layout>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-window-item>

        <!-- location settings -->
        <v-window-item :value="3">
          <v-card-text>
            <div style="text-align: center; padding: 0px 25px">
              <h4 class="title font-weight-light">Location</h4>
              <p>Set up a Location for your Organization</p>
            </div>

            <v-divider style="margin: 10px 0px"></v-divider>

            <v-layout row class="pa-1">
              <v-flex xs12 sm12 md12 style="padding: 0px 10px">
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <GmapMap
                      ref="mapRef"
                      :center="editedItem.locationSettings.coordinates"
                      :zoom="12"
                      map-type-id="terrain"
                      style="min-width: 200px; min-height: 300px;width:100%"
                    >
                      <GmapMarker
                        :position="editedItem.locationSettings.coordinates"
                        :clickable="true"
                        :draggable="true"
                        @dragend="updateLoc"
                        :icon="{
                          url: require('@/assets/ft.png'),
                          size: { width: 45, height: 45, f: 'px', b: 'px' },
                          scaledSize: { width: 45, height: 45, f: 'px', b: 'px' }
                        }"
                      />
                      <gmap-circle
                        :center="editedItem.locationSettings.coordinates"
                        :radius="editedItem.locationSettings.radius"
                      ></gmap-circle>
                    </GmapMap>
                    <div style="text-align: right">
                      <v-btn
                        @click="geoCurrentLocation"
                        fab
                        small
                        style="background-color: #fff ;margin-top: -110px; margin-right: 60px"
                      >
                        <v-icon>my_location</v-icon>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 style="margin-bottom: 7px">
                    <gmap-autocomplete
                      :value="editedItem.locationSettings.address"
                      @place_changed="setPlace"
                      :select-first-on-enter="true"
                      label="Location"
                      class="input"
                      placeholder="Enter a address"
                    ></gmap-autocomplete>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 style="margin-bottom: 7px">
                    <v-expansion-panels>
                      <v-expansion-panel v-for="(item, i) in 1" :key="i">
                        <v-expansion-panel-header expand-icon="mdi-menu-down">
                          <v-flex xs12 text-xs-right class="customFont">Advanced Options</v-flex>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-layout row wrap>
                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                v-model="editedItem.locationSettings.name"
                                :rules="locationNameRules"
                                label="Location name"
                                required
                              ></v-text-field>
                            </v-flex>
                          </v-layout>

                          <v-layout row wrap>
                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                v-model="editedItem.locationSettings.radius"
                                @input="checkRadius"
                                :rules="rulesRadius"
                                type="number"
                                label="Radius"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>

                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6 style="padding: 0px 5px">
                              <v-text-field
                                @input="updateLoc()"
                                v-model="latLngBox.lat"
                                :value="editedItem.locationSettings.coordinates.lat"
                                label="Lat"
                              ></v-text-field>
                            </v-flex>

                            <v-flex xs6 sm6 md6 style="padding: 0px 5px">
                              <v-text-field
                                @input="updateLoc()"
                                v-model="latLngBox.lng"
                                :value="editedItem.locationSettings.coordinates.lng"
                                label="long"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>

                          <v-layout row wrap>
                            <v-flex xs10 sm10 md10>
                              <v-autocomplete
                                v-model="editedItem.locationSettings.wifi"
                                :items="wifiList"
                                :return-object="true"
                                item-text="SSID"
                                label="Select Wifi (Mobile Only)"
                                clearable
                                chips
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-btn
                                key="icon-true"
                                @click="updateWifi"
                                class="md-2"
                                style="background: transparent; border: none; box-shadow: none;"
                                fab
                              >
                                <v-icon>network_wifi</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-window-item>

        <!-- fieldTracking Setting -->
        <v-window-item :value="4">
          <v-card-text>
            <div style="text-align: center; padding: 0px 40px">
              <h4 class="title font-weight-light">Field Tracking</h4>
              <p>Field Reporting and Live Location Tracking</p>
            </div>

            <v-divider style="margin: 10px 0px"></v-divider>

            <v-layout row class="pa-1">
              <v-flex xs12 sm12 style="padding: 0px 10px ">
                <v-layout row wrap>
                  <v-flex xs10 sm9 style="text-align: left">
                    <h3>Mark Location</h3>
                    <small>Records GPS-based Information for Field Visits</small>
                  </v-flex>
                  <v-flex xs2 sm3 style="text-align: right">
                    <v-switch
                      v-model="editedItem.fieldTrackingSettings.enabled"
                      color="primary"
                      light
                    ></v-switch>
                  </v-flex>
                </v-layout>

                <v-layout
                  v-if="editedItem.fieldTrackingSettings.enabled == true"
                  row
                  wrap
                  style="padding-left: 30px"
                >
                  <v-flex xs10 sm9 style="text-align: left">
                    <h3>Take Picture</h3>
                    <small>Records Photo for Field Visits</small>
                  </v-flex>
                  <v-flex xs2 sm3 style="text-align: right">
                    <v-switch
                      v-model="editedItem.fieldTrackingSettings.isPhotoid"
                      style="margin-left: -7px"
                      color="primary"
                      light
                    ></v-switch>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs10 sm9 style="text-align: left">
                    <h3>Realtime Route & Trip Tracking</h3>
                    <small>Tracks Live Route Information for Trips</small>
                  </v-flex>
                  <v-flex xs2 sm3 style="text-align: right">
                    <v-switch
                      v-model="editedItem.realtimeFieldTrackingSettings.enabled"
                      color="primary"
                      light
                    ></v-switch>
                  </v-flex>
                </v-layout>

                <!--  <v-layout row wrap>
                  <v-flex xs10 sm9 style="text-align: left">
                    <h3>Dynamic Forms</h3>
                    <small>
                      Create Custom Forms and Accept Responses in Seconds. Powered with GPS and
                      Photo Tagging.
                    </small>
                  </v-flex>
                  <v-flex xs2 sm3 style="text-align: right">
                 
                    <v-switch color="primary" light></v-switch>
                  </v-flex>
                </v-layout> -->
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-window-item>

        <!-- add member section -->
        <v-window-item :value="5">
          <v-card-text>
            <div style="text-align: center; padding: 0px 40px">
              <h4 class="title font-weight-light">Add Your Members</h4>
              <p>Add Members to your Organization</p>
            </div>

            <v-divider style="margin: 10px 0px"></v-divider>

            <v-layout row>
              <v-flex xs12 sm12 style="padding: 0px 10px">
                <v-card>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12 style="padding: 1px 4px">
                      <v-card elevation="2">
                        <v-card-title class="text-xs-center">
                          <h3 class="text-xs-center">Enter Member Details</h3>
                        </v-card-title>

                        <v-card-text>
                          <v-flex xs12 sm10 offset-sm1 md10 offset-md1>
                            <v-layout row wrap>
                              <v-flex xs6 sm6 style="padding: 0px 5px">
                                <v-text-field
                                  v-model="memberObj.firstName"
                                  label="First Name"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs6 sm6 style="padding: 0px 5px">
                                <v-text-field
                                  v-model="memberObj.lastName"
                                  label="Last Name"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex xs12 sm6 style="padding: 0px 5px">
                                <v-text-field
                                  v-model="memberObj.email"
                                  label="Email Id"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 sm3 style="padding: 0px 5px;">
                                <v-switch v-model="memberObj.isAdmin" label="Manager"></v-switch>
                              </v-flex>
                              <v-flex
                                xs6
                                sm3
                                style="padding: 0px 5px; text-align: right; margin: 5px 0px 0px 0px"
                              >
                                <v-btn @click="addMember" color="primary">Add</v-btn>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-card-text>
                      </v-card>
                    </v-flex>

                    <v-flex v-if="addedMember.length > 0" xs12 sm12 md12 style="padding: 1px 4px">
                      <v-divider style="6px 0px;border-radius:0px;"></v-divider>
                      <v-card
                        v-for="(user, i) in addedMember"
                        :key="i"
                        elevation="1"
                        style="border-radius: 2px; margin: 10px 0px; box-shadow: 2px 3px 18px #404040; border-left: 4px solid #4772d9 !important"
                      >
                        <v-card-text>
                          <v-flex xs12 sm12>
                            <v-layout row wrap align-center justify-center>
                              <v-flex xs6 sm2>{{ user.firstName }}</v-flex>
                              <v-flex xs6 sm2>{{ user.lastName }}</v-flex>
                              <v-flex xs6 sm4>{{ user.email }}</v-flex>
                              <v-flex v-if="user.role == 'Admin'" xs6 sm2>Is Manager ? Yes</v-flex>
                              <v-flex v-else xs6 sm2>Is Manager ? No</v-flex>
                              <v-flex xs6 sm2 style="text-align: center">
                                <v-icon @click="deleteAddedMember(user, i)" small color="error"
                                  >delete</v-icon
                                >
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-window-item>

        <v-divider style="margin: 10px 0px"></v-divider>

        <v-row>
          <v-col cols="6" md="6">
            <v-btn v-if="step > 1" @click="step--" color="#141414" text>Back</v-btn>
          </v-col>
          <v-col cols="6" md="6" style="text-align: right">
            <v-btn v-if="step === 5" @click="skipStep" text color="#141414">Skip</v-btn>
            <v-btn
              v-if="step === 1 || step === 2 || step === 3 || step === 4"
              @click="step++"
              color="accent"
              depressed
              >Next</v-btn
            >
            <v-btn
              v-if="step === 5"
              :disabled="ftsSubmit"
              @click="firstTimeDataSave"
              color="green"
              class="white--text"
              >Finish</v-btn
            >
          </v-col>
        </v-row>
      </v-window>
    </v-dialog>

    <v-dialog v-model="loaderDialog" persistent width="300">
      <v-card color="primary" style="padding: 5px">
        <v-card-text style="padding: 10px; color: #fcfcfc">
          <h3 style="font-size: 15px;color: #fcfcfc; margin: 7px 0px">Please stand by</h3>
          <v-progress-linear
            style="padding: 2px"
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment-timezone";
import wifi from "@/utilities/wifi";

export default {
  data: () => ({
    // member addition
    ftsSubmit: false,
    loaderDialog: false,
    addedMember: [],
    wifiList: [],
    memberObj: {
      firstName: "",
      lastName: "",
      email: "",
      isAdmin: false
    },
    rulesRadius: [
      v => !!v || "Radius is required",
      v => (v > 100 && v < 20037510) || "Enter a realistic radius more than 100"
    ],
    dialogFirstTime: false,
    notifications: false,
    sound: true,
    widgets: false,
    formatedAddresses: [],
    locations: [],
    addresses: [],
    step: 1,
    computeLogo: require("@/assets/nomembers.png"),
    latLng: { lat: 22.2232, lng: 88.2232 },
    center: { lat: 22.2232, lng: 88.2232 },
    timeZones: [],
    placeholder: "Address",
    latLngBox: { lat: 22.22, lng: 88.22 },
    editedItem: {
      locationSettings: {
        name: "Default Location",
        address: "1540 Broadway, New York, NY 10036, United States",
        tz: {},
        radius: 300,
        wifi: "",
        coordinates: {
          lat: 40.757873,
          lng: -73.9875707
        }
      },
      securitySettings: {
        isFieldtracking: false,
        isGeoseal: false,
        isPhotoid: false,
        matchDevice: false,
        isRealtimeFieldtracking: false,
        isWifissid: false,
        // isHuddle: false,
        detectHotspot: false
      },
      fieldTrackingSettings: {
        enabled: false,
        isPhotoid: false
      },
      realtimeFieldTrackingSettings: {
        enabled: false
      },
      companyId: ""
    },
    locationNameRules: [
      v => !!v || "Please provide a location name",
      v => /^[A-Za-z0-9\-][a-zA-Z0-9 ]+[a-zA-Z0-9]*$/.test(v) || "Enter a valid Location Name"
    ],
    generalSettings: [
      {
        icon: "folder",
        iconClass: "grey lighten-1 white--text",
        title: "Photos",
        subtitle: "Jan 9, 2014"
      },
      {
        icon: "folder",
        iconClass: "grey lighten-1 white--text",
        title: "Recipes",
        subtitle: "Jan 17, 2014"
      },
      {
        icon: "folder",
        iconClass: "grey lighten-1 white--text",
        title: "Work",
        subtitle: "Jan 28, 2014"
      }
    ]
  }),

  computed: {
    firstTimeState() {
      if (this.$store.getters.firstTimeSetup == true) {
        this.$router.push("/");
      }

      return this.$store.getters.firstTimeSetup;
    }
  },
  watch: {
    firstTimeState(newState, oldState) {
      if (newState == true || oldState == true) {
        this.$router.push("/");
      }
    },
    step(oldV, newV) {
      if (newV == 2) {
        setTimeout(() => {
          this.setAddress();
        }, 1000);
      }
    }
  },
  created() {
    var self = this;
    this.dialogFirstTime = true;
    this.timeZones = moment.tz.names();
    const timezone = moment.tz.names();
    this.editedItem.locationSettings.tz = moment.tz.guess();
    this.editedItem.companyId = this.$store.state.userDetails.companyId;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.editedItem.locationSettings.coordinates = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };

        self.latLngBox = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };

        setTimeout(function() {
          self.setAddress();
        }, 2000);
      });
    } else {
    }
  },

  methods: {
    skipStep() {
      this.step++;
      this.addedMember = [];

      this.firstTimeDataSave();
    },

    async updateWifi() {
      if (this.$mq == "mobile") {
        try {
          this.wifiList = await wifi.list();
        } catch (e) {
          console.log(e);
        }
      } else {
        this.wifiList = [];
      }
    },

    addMember() {
      var self = this;
      // checking for same enrty
      if (
        self.addedMember.filter(f => {
          return self.memberObj.email == f.email;
        }).length > 0
      ) {
        return self.$swal({ type: "warning", text: "Email already exists" });
      }
      // checking if blank
      if (self.memberObj.firstName == "" || self.memberObj.email == "") {
        return self.$swal({
          type: "warning",
          text: "Required fields are empty"
        });
      }
      // checking if valid
      if (
        !/^[A-Za-z0-9\-][a-zA-Z0-9 ]+[a-zA-Z0-9]*$/.test(self.memberObj.firstName) ||
        !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w+)+$/.test(self.memberObj.email)
      ) {
        return self.$swal({
          type: "warning",
          text: "Please check the member details"
        });
      }

      var postObj = {
        firstName: self.memberObj.firstName,
        lastName: self.memberObj.lastName,
        email: self.memberObj.email
      };
      if (self.memberObj.isAdmin) {
        postObj.role = "Admin";
      } else {
        postObj.role = "User";
      }

      self.addedMember.push(postObj);

      // clear the history
      self.memberObj = {
        firstName: "",
        lastName: "",
        email: "",
        isAdmin: false
      };
    },
    deleteAddedMember(user, index) {
      this.addedMember.splice(index, 1);
    },

    geoCurrentLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.editedItem.locationSettings.coordinates = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          this.latLngBox = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          this.setAddress();
        });
      }
    },

    check() {
      this.$store.dispatch("checkFirstTimeSetup", this.$store.getters.userDetails.companyId);
    },

    updateLoc(newAddress) {
      const self = this;

      if (newAddress) {
        this.editedItem.locationSettings.coordinates = {
          lat: newAddress.latLng.lat(),
          lng: newAddress.latLng.lng()
        };

        this.latLngBox = {
          lat: newAddress.latLng.lat(),
          lng: newAddress.latLng.lng()
        };
      } else {
        this.editedItem.locationSettings.coordinates = {
          lat: Number(this.latLngBox.lat),
          lng: Number(this.latLngBox.lng)
        };
      }

      this.setAddress();
    },

    setAddress() {
      const self = this;

      //this.$refs.mapRef.$mapPromise.then(() => {

      const geocoder = new google.maps.Geocoder();

      geocoder.geocode(
        { location: this.editedItem.locationSettings.coordinates },
        (results, status) => {
          if (status === "OK") {
            if (results[0]) {
              self.editedItem.locationSettings.address = results[0].formatted_address;
            } else {
              return null;
            }
          }
        }
      );
      // })
    },

    /* checkValidation(mode){

        if(mode == "geo" || mode == "wifi"){
          if (this.editedItem.securitySettings.isGeoseal == true || this.editedItem.securitySettings.isWifissid == true){
              this.editedItem.fieldTrackingSettings.enabled = false
            }
        }
        else if(mode == "ft"){
          if (this.editedItem.fieldTrackingSettings.enabled == true ){
            this.editedItem.securitySettings.isGeoseal = false
            this.editedItem.securitySettings.isWifissid = false
          }
        }

      },
      */
    checkRadius() {
      this.editedItem.locationSettings.radius = Number(this.editedItem.locationSettings.radius);
    },
    setPlace(place) {
      this.editedItem.locationSettings.address = place.formatted_address;

      this.editedItem.locationSettings.coordinates = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };

      this.latLngBox = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
    },
    autoDetectTimeZone() {
      this.editedItem.locationSettings.tz = moment.tz.guess();
    },

    firstTimeDataSave() {
      this.ftsSubmit = true;
      this.loaderDialog = true;
      var error = false;
      const itemObj = JSON.parse(JSON.stringify(this.editedItem));

      if (itemObj.locationSettings.name == "") {
        itemObj.locationSettings.name = "Default Location Name";
      }

      if (itemObj.locationSettings.radius < 100) {
        this.$swal({
          type: "warning",
          text: "Minimum allowed radius is 300"
        });
        error = true;
      }
      if (itemObj.locationSettings.radius >= 20037510) {
        this.$swal({
          type: "warning",
          text: "Regular.li works only on earth. For now. Please reduce allowed radius."
        });
        error = true;
      }

      if (error) {
        this.ftsSubmit = false;
        this.loaderDialog = false;
        return;
      }

      const selectedTimezone = itemObj.locationSettings.tz;
      const toOffset = moment()
        .tz(selectedTimezone)
        .utcOffset()
        .toString();

      itemObj.locationSettings.tz = {
        name: selectedTimezone,
        offset: toOffset
      };
      //Adding users during first time setup
      itemObj.members = this.addedMember;

      this.$http.post(`${this.$store.state.endpoint}companies/firstSetup`, itemObj).then(
        response => {
          this.$store.dispatch("checkFirstTimeSetup");
          this.$store.dispatch("getUserData", {
            userId: this.$store.state.userDetails.id
          });

          // this.ftsSubmit = false;
          // this.loaderDialog = false;
        },
        error => {
          this.ftsSubmit = false;
          this.loaderDialog = false;

          this.$swal({
            type: "warning",
            text: error.body.error.message
          });
        }
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main_window {
  background-color: #fff;
  padding: 5px;
  border-radius: 3px;
  -webkit-box-shadow: none!imporant;
  box-shadow: none!imporant;
}

/* custom css */
h3 {
  font-size: 18px;
  letter-spacing: 0.5px;
}
p {
  font-size: 13px;
  font-weight: 500;
}
h4 {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-bottom: 7px;
}
.main_window {
  background-color: #fff;
  padding: 5px;
  border-radius: 3px;
  -webkit-box-shadow: none!imporant;
  box-shadow: none!imporant;
}
/* end of custom css */

.v-input--selection-controls.v-input.v-label {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  top: 0;
  height: auto;
  color: white !important;
}

.gps-btn {
  /* margin-left: 327px;
  z-index: 1;
  top: -35px; */
  margin-left: -80px;
  background: transparent !important;
  box-shadow: none !important;
}
@media only screen and (max-width: 600px) {
  .gps-btn {
    margin-left: -75px;
  }
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.listHeightFix .v-list__tile__title {
  height: 40px;
}

.group {
  position: relative;
}
input {
  font-size: 17px;

  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
}
input:focus {
  outline: none;
}

/* LABEL ======================================= */
label {
  color: #999;
  font-size: 17px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  top: 10px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

/* active state */
input:focus ~ label,
input:valid ~ label {
  top: -20px;
  font-size: 14px;
  color: #0000ff;
}

/* BOTTOM BARS ================================= */
.bar {
  position: relative;
  display: block;
  width: 100%;
}
.bar:before,
.bar:after {
  content: "";
  height: 1px;
  width: 0;
  bottom: 1px;
  position: absolute;
  background: #0000ff;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}
.bar:before {
  left: 50%;
}
.bar:after {
  right: 50%;
}

/* active state */
input:focus ~ .bar:before,
input:focus ~ .bar:after {
  width: 50%;
}

/* HIGHLIGHTER ================================== */
.highlight {
  position: absolute;
  height: 60%;
  width: 100px;
  top: 25%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
}

/* active state */
input:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

.v-expansion-panel__header > .v-expansion-panel__header__icon {
  flex: 1 1 auto !important;
}

.customFont {
  font-size: 0.8rem;
}

/* ANIMATIONS ================ */
@-webkit-keyframes inputHighlighter {
  from {
    background: #0000ff;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #0000ff;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #0000ff;
  }
  to {
    width: 0;
    background: transparent;
  }
}
</style>
